module.exports = __webpack_public_path__ + "img/Background-create2.c33acafc.svg";